var exports = {};

/**
 * Converts list into array
 */
exports = function toArray(list) {
  return Array.prototype.slice.call(list || [], 0);
};

export default exports;